import { Util } from './../_classes/util';
import { tap, catchError, take } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { ElogioPunicao } from './../_classes/elogio-punicao';
import { Observable, Subject, EMPTY, timer } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { ModalAjudaService } from '../shared/modal-ajuda.service';
import { EnvService } from '../_servicos/env.service';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';

@Component({
  selector: 'app-elogio',
  templateUrl: './elogio.component.html',
  styleUrls: ['./elogio.component.scss'],
})
export class ElogioComponent implements OnInit {
  private readonly recurso: string = 'elogio';

  carregando = false;
  displayedColumns: string[] = [
    'dtEloPunicao',
    'tpEloPunicao',
    'descEloPunicao',
    'penalidade',
  ];

  //servidor$: Observable<Servidor>;
  //servidor: Servidor = new Servidor();

  erros$ = new Subject<boolean>();
  dataSource$: Observable<ElogioPunicao[]>;
  dataSource: MatTableDataSource<ElogioPunicao>;

  itensAjuda = [
    { titulo: 'Data', texto: 'Data e protocolo' },
    {
      titulo: 'Tipo',
      texto: 'Este indica se foi recebido um elogio ou uma punição',
    },
    { titulo: 'Descrição', texto: 'Informa a descrição do evento' },
    {
      titulo: 'Penalidade',
      texto: 'Qual penalidade foi atribuída (quando o tipo for punição)',
    },
  ];

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private ajudaService: ModalAjudaService,
    private env: EnvService
  ) {}

  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  ngOnInit() {
    this.atualizar();
  }
  /*
  executarAoCarregarServidor(x: Servidor) {
      this.env.servidor = new Servidor(x);
    }
*/
  executarAoCarregarDatasource(x: ElogioPunicao[]) {
    this.dataSource = new MatTableDataSource<ElogioPunicao>(x);
    this.carregando = false;
  }

  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );
    this.dataSource$ = this.service
      .listarElogioPunicao(this.env.servidor.idServidor)
      .pipe(
        tap((a) => this.executarAoCarregarDatasource(a)),
        take(1),
        catchError((e) => {
          this.handleError(e);
          return EMPTY;
        })
      );
  }

  /*
  atualizarOld() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    this.servidor = this.servService.getServidorAtualRedirecionando('elogio');

    this.servidor$ = this.servService.getServidor().pipe(
      tap((x) => this.executarAoCarregarServidor(x)),
      take(1),
      catchError((e) => {
        this.handleError(e);
        return empty();
      })
    );

    if (this.servidor) {
      this.dataSource$ = this.service
        .listarElogioPunicao(this.servidor.idServidor)
        .pipe(
          tap((a) => this.executarAoCarregarDatasource(a)),
          take(1),
          catchError((e) => {
            this.handleError(e);
            return empty();
          })
        );
    }
  }*/

  mostrarAjudaModal() {
    this.ajudaService.mostrar(this.itensAjuda, '');
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
